import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
// Define a type for the slice state
interface HeaderState {
  isConfirmationModalOpen: boolean;
  disableConfirmedTab: boolean;
  defaultHeaderLogo: string;
  headerLogo: string;
  altName: string | null;
  availableCategories: string[];
}

// Define the initial state using that type
const initialState: HeaderState = {
  isConfirmationModalOpen: false,
  disableConfirmedTab: true,
  defaultHeaderLogo: '/logos/default.png',
  headerLogo: '',
  altName: null,
  availableCategories: [],
};

// Create the slice
const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    handleHeaderConfirmationModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isConfirmationModalOpen = action.payload;
    },
    handleConfirmedTabDisableState: (state, action: PayloadAction<boolean>) => {
      state.disableConfirmedTab = action.payload;
    },
    handleHeaderLogo: (
      state,
      action: PayloadAction<{ defaultHeaderLogo: string; headerLogo: string; altName: string }>,
    ) => {
      state.defaultHeaderLogo = action.payload.defaultHeaderLogo;
      state.headerLogo = action.payload.headerLogo;
      state.altName = action.payload.altName;
    },
    setAvailableCategories: (state, action: PayloadAction<string[]>) => {
      state.availableCategories = action.payload;
    },
  },
});

// Export the actions
export const {
  handleHeaderConfirmationModalOpen,
  handleConfirmedTabDisableState,
  handleHeaderLogo,
  setAvailableCategories,
} = headerSlice.actions;

// Export the reducer
export default headerSlice.reducer;
